"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStatusTrackingPredicateConfigured = isStatusTrackingPredicateConfigured;
exports.shouldKeepRowForStatusTracking = shouldKeepRowForStatusTracking;
function lookupOptionLabel(value, options) {
    if (!options) {
        return value;
    }
    if (options instanceof Map) {
        return options.get(value) ?? value;
    }
    return options[value] ?? value;
}
function valueToComparableStrings(value, options) {
    if (value === null || value === undefined) {
        return [''];
    }
    if (Array.isArray(value)) {
        return value.flatMap(item => valueToComparableStrings(item, options));
    }
    if (typeof value === 'string') {
        return [lookupOptionLabel(value, options)];
    }
    if (typeof value === 'object') {
        const record = value;
        if (typeof record.value === 'string') {
            return [record.value];
        }
        if (typeof record.id === 'string') {
            return [lookupOptionLabel(record.id, options)];
        }
    }
    return [String(value)];
}
function normalizeComparable(value) {
    return String(value ?? '')
        .trim()
        .toLowerCase();
}
function isStatusTrackingPredicateConfigured(predicate) {
    return (predicate?.enabled === true &&
        typeof predicate.columnId === 'string' &&
        predicate.columnId.trim().length > 0 &&
        predicate.successValue !== null &&
        predicate.successValue !== undefined &&
        String(predicate.successValue).trim().length > 0);
}
function shouldKeepRowForStatusTracking(predicate, cellValue, options) {
    if (!predicate?.enabled) {
        return true;
    }
    if (!isStatusTrackingPredicateConfigured(predicate)) {
        throw new Error('Status tracking is enabled but columnId or successValue is missing');
    }
    const successValue = normalizeComparable(predicate.successValue);
    return !valueToComparableStrings(cellValue, options).some(value => normalizeComparable(value) === successValue);
}
